{
    "form_error_required": "Required",
    "sales_draft__list_view__header__customer": "Customer",
    "sales_draft__list_view__header__creation_date": "Creation date",
    "sales_draft__list_view__header__total": "Total",
    "sales_draft__list_view__header__positions": "Positions",
    "sales_draft__list_view__header__created_by": "Created by",
    "sales_draft__list_view__action__edit": "Edit",
    "sales_draft__list_view__action__delete": "Delete",
    "sales_draft__list_view__filter_customers": "Customers",
    "sales_draft__list_view__filter_users": "Created by",
    "sales_draft__list_view__filter_states": "Status",
    "sales_draft__list_view__search_placeholder": "Search by customer",
    "sales_draft__header__sub_title__order": "New Order",
    "sales_draft__header__sub_title__quote": "New Quote",
    "sales_draft__button_group__search_catalog": "Catalog",
    "sales_draft__stepper__line_items": "Individual items",
    "sales_draft__stepper__header": "Header",
    "sales_draft__summary__overview": "Overview",
    "sales_draft__summary__number_of_positions": "Number of items",
    "sales_draft__summary__contribution_margin_percent": "Gross margin %",
    "sales_draft__summary__contribution_margin": "Gross margin",
    "sales_draft__summary__total_position": "Total items",
    "sales_draft__button_group__continue": "Continue to Header",
    "sales_draft__button_group__cancel": "Cancel",
    "sales_draft__line_items__table_header__article": "Article",
    "sales_draft__line_items__table_header__quantity": "Quantity",
    "sales_draft__line_items__table_header__price": "Price",
    "sales_draft__line_items__table_header__rebate": "Rebate",
    "sales_draft__line_items__table_header__gross_margin_percent": "GM %",
    "sales_draft__edit__line_item": "Edit more",
    "sales_draft__delete__line_item": "Delete",
    "sales_draft__item_form__quantity": "Quantity",
    "sales_draft__item_form__price": "Price",
    "sales_draft__item_form__rebate": "Rebate",
    "sales_draft__item_form__gross_margin_percent": "Gross margin %",
    "sales_draft__item_form__gross_margin": "Gross margin",
    "sales_draft__item_form__total": "Total",
    "sales_draft__item_form__storage": "Storage location",
    "sales_draft__item_form__storage_from_header": "From header ({{id}}: {{name}})",
    "sales_draft__item_form__shipping_type_id": "Shipping type",
    "sales_draft__item_form__note": "Line note",
    "sales_draft__item_form__encoded_price": "Commodity code",
    "sales_draft__cancel_confirmation_dialog__title": "Cancel and delete transaction?",
    "sales_draft__cancel_confirmation_dialog__description": "The operation is not saved. This action cannot be undone.",
    "sales_draft__cancel_confirmation_dialog__accept": "Delete transaction",
    "sales_draft__cancel_confirmation_dialog__reject": "Continue editing",
    "sales_draft__delete_success_toast__title": "Draft successfully deleted",
    "sales_draft__delete_success_toast__description": "Here you can <linkTag>create a new transaction</linkTag>",
    "sales_draft__button_group__back_to_line_items": "Back",
    "sales_draft__button_group__submit": "Save in ERP system",
    "sales_draft__header__billing_address": "Billing address",
    "sales_draft__header__shipping_address": "Select delivery address",
    "sales_draft__header__contact_person": "Contact person",
    "sales_draft__header__contact_person__select": "Select contact person",
    "sales_draft__header__delivery_date": "Desired date",
    "sales_draft__header__order_type": "Order type",
    "sales_draft__header__order_type__select": "Select order type",
    "sales_draft__header__shipping_type": "Default shipping type",
    "sales_draft__header__shipping_type__select": "Select shipping type",
    "sales_draft__header__commission": "PO number",
    "sales_draft__header__notes": "Header text",
    "sales_draft__header__notes_placeholder": "Add a note for customers that will be displayed on PDF documents",
    "sales_draft__header__due_date": "Valid until",
    "sales_draft__header__quote_type": "Quote type",
    "sales_draft__header__quote_type__select": "Select quote type",
    "sales_draft__header__submit_error": "Error while saving in the ERP system",
    "sales_draft__ORDER__submit_confirmation_dialog__title": "Save order in ERP system?",
    "sales_draft__ORDER__submit_confirmation_dialog__description": "The order is saved in the ERP system and can no longer be processed in Plato.",
    "sales_draft__ORDER__submit_success_toast__title": "Order successfully saved in the ERP system",
    "sales_draft__ORDER__submit_success_toast__description": "It will soon be visible to everyone in the ERP system",
    "sales_draft__QUOTE__submit_confirmation_dialog__title": "Save quote in ERP system?",
    "sales_draft__QUOTE__submit_confirmation_dialog__description": "The quote is saved in the ERP system and can no longer be processed in Plato.",
    "sales_draft__QUOTE__submit_success_toast__title": "Quote successfully saved in the ERP system",
    "sales_draft__QUOTE__submit_success_toast__description": "It will soon be visible to everyone in the ERP system",
    "sales_draft__submit_confirmation_dialog__accept": "Confirm",
    "sales_draft__submit_confirmation_dialog__reject": "Keep editing",
    "sales_draft__delete_confirmation_dialog__title": "Delete this draft?",
    "sales_draft__delete_confirmation_dialog__description": "The draft will be permanently deleted. This action cannot be undone.",
    "sales_draft__submit_error_toast__title": "Error while saving in the ERP system",
    "sales_draft__submit_error_toast__description": "The draft could not be saved. Please try again.",
    "sales_draft__update_error_toast__title": "Error while saving the draft",
    "sales_draft__update_error_toast__description": "The draft could not be saved. Please try again.",
    "sales_draft__quick_filters__by_me": "My drafts",
    "sales_draft__quick_filters__submitted": "Recently submitted to ERP",
    "sales_draft__list_view__action__view": "View transaction",
    "sales_draft__status__NEW": "Draft",
    "sales_draft__status__SUBMITTED": "Submitted",
    "sales_draft__recommended_header": "Recommended Products",
    "sales_draft__recommended_header__customer": "Top products for this customer",
    "sales_draft__recommended_header__tenant": "Top-selling products",
    "sales_draft__recommended_loading": "Loading",
    "sales_draft__recommended_none": "No more recommended products to show",
    "sales_draft__related_items_header": "Related items",
    "sales_draft__incremental_quantity_dialog__title": "Package unit cannot be broken",
    "sales_draft__incremental_quantity_dialog__description": "Select a multiple of the package unit",
    "sales_draft__incremental_quantity_dialog__confirm": "Add",
    "sales_draft__error_no_unit": "No sales unit found",
    "sales_draft__error_stock": "Error looking up stock"
}
